import { forwardRef } from "react";

import PropTypes from "prop-types";

import { headerCss } from "./SectionHeader.style";

const propTypes = {
  headerText: PropTypes.string.isRequired,
  tabIndex: PropTypes.string,
};

const SectionHeader = forwardRef(({ headerText, tabIndex }, ref) => {
  if (!headerText) return null;

  return (
    <h3 css={headerCss} ref={ref} tabIndex={tabIndex}>
      {headerText}
    </h3>
  );
});

SectionHeader.propTypes = propTypes;
export default SectionHeader;
